// extracted by mini-css-extract-plugin
export var active = "_2c-d";
export var blink = "_2c-e";
export var container = "_2c-5";
export var controls = "_2c-0";
export var controlsRight = "_2c-1";
export var fakeCursor = "_2c-c";
export var hidden = "_2c-b";
export var quillContainerSmall = "_2c-7";
export var quillEditor = "_2c-6";
export var quillEditorSmall = "_2c-8";
export var quillFormatButtons = "_2c-a";
export var quillToolbar = "_2c-9";
export var removePadding = "_2c-2";
export var state = "_2c-3";
export var stateTitle = "_2c-4";